<template>
  <section class="section">
    <div class="section-body">
      <div class="card">
        <div class="card-header">
          <v-icon color="#28a745">search</v-icon>
          <h4>{{ $t("messages.general.searchShowInfo") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.academicYear") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChanged"
                      :selectedVal="selYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.semester") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChanged"
                      :selectedVal="selSemester"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level :onChanged="onSelLvlChanged" :selectedVal="selLvl" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.classId") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <input
                        type="text"
                        class="form-control col mr-2"
                        v-model="txtCourseCode"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.className") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <input
                        type="text"
                        class="form-control col mr-2"
                        v-model="txtCourseName"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.faculty") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Faculty
                      :onChanged="onSelFacultyChanged"
                      :selectedVal="selFaculty"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.department") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Department
                      :onChanged="onSelDepartmentChanged"
                      :facultyid="selFaculty"
                      :selectedVal="selDepartment"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.classGroup") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <ClassType
                      :onChanged="onSelClassTypeChanged"
                      :selectedVal="selClassType"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleSearchCls()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-light btn-lg"
                    @click="handleClearSearchCls()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTable.sortBy"
              :sort-desc.sync="bTable.sortDesc"
              :items="bTable.items"
              :fields="bTable.fields"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTable.items.length"
                  v-model="currentPage"
                  :per-page="perPage"
                />
                <div
                  v-if="bTable.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPage > 1
                        ? (currentPage - 1) * perPage + 1
                        : currentPage
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPage * perPage > bTable.items.length
                        ? bTable.items.length
                        : currentPage * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTable.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
              </template>

              <template v-slot:cell(action)="data">
                <v-btn text icon @click="openDialog(data.item, data.index)">
                  <v-icon>search</v-icon>
                </v-btn>
              </template>

              <template v-slot:cell(RESERVEONLY)="data">
                <v-icon v-if="data.item.RESERVEONLY == 'Y'">fa-check</v-icon>
              </template>

              <template v-slot:cell(CLASSTIME)="data">
                <div v-html="data.item.CLASSTIME">
                  {{ data.item.CLASSTIME }}
                </div>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTable.items.length"
                    v-model="currentPage"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTable.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPage > 1
                          ? (currentPage - 1) * perPage + 1
                          : currentPage
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPage * perPage > bTable.items.length
                          ? bTable.items.length
                          : currentPage * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTable.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
          <br />
          <div style="font-size: 16px; margin-top: 45px">
            <strong>{{ $t("messages.general.remark") }}</strong>
          </div>
          <div style="padding-left: 30px">
            <p style="font-size: 16px;">
              {{ $t("messages.reqRegister.remarkClassStatusO") }}<br />
              {{ $t("messages.reqRegister.remarkClassStatusC") }}<br />
              {{ $t("messages.reqRegister.remarkClassStatusCOP") }}
            </p>
          </div>

          <v-dialog v-model="dialog" hide-overlay scrollable max-width="80%">
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>edit</v-icon>
                <v-toolbar-title>{{
                  $t("messages.general.classDetail")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <div class="information-block">
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.academicYear") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classDetail.ACADYEAR }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.semester") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classDetail.SEMESTER }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.classId") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classDetail.COURSECODE }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.className") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classDetail.COURSENAME }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.credit") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classDetail.COURSEUNIT }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.faculty") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classDetail.FACULTYNAME }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.classStatus") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classDetail.COURSESTATUS }}</div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
                <div class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th class="text-center">
                          {{ $t("messages.general.section") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.classType") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.classTime") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.room") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.receiveAmount") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.registerAmount") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.remainAmount") }}
                        </th>
                        <th class="text-center">
                          {{ $t("messages.general.requestAmount") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center">{{ classDetail.SECTION2 }}</td>
                        <td class="text-center" v-html="classDetail.CLASSTYPE">
                          {{ classDetail.CLASSTYPE }}
                        </td>
                        <td
                          class="text-center"
                          style="white-space: nowrap"
                          v-html="classDetail.CLASSTIME"
                        >
                          {{ classDetail.CLASSTIME }}
                        </td>
                        <td
                          class="text-center"
                          style="white-space: nowrap"
                          v-html="classDetail.CLASSROOM"
                        >
                          {{ classDetail.CLASSROOM }}
                        </td>
                        <td class="text-center">{{ classDetail.TOTALSEAT }}</td>
                        <td class="text-center">
                          {{ classDetail.TOTALSUMSEAT }}
                        </td>
                        <td class="text-center">
                          {{ classDetail.TOTALSEAT - classDetail.TOTALSUMSEAT }}
                        </td>
                        <td class="text-center">
                          {{ classDetail.ENROLLSEAT }}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="9" style="padding: 0 !important">
                          <v-expansion-panels
                            accordion
                            style="height: 100%; border-radius: 0 !important"
                          >
                            <v-expansion-panel>
                              <v-expansion-panel-header>{{
                                $t("messages.general.moreDetail")
                              }}</v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <div class="information-block">
                                  <div class="row">
                                    <div class="col no-padding-bottom">
                                      <div class="information-detail">
                                        <div
                                          class="col no-margin-padding"
                                          style="flex: 0 0 10em;"
                                        >
                                          <div>
                                            {{
                                              $t("messages.general.teachers")
                                            }}
                                          </div>
                                        </div>
                                        <div class="col no-margin-padding">
                                          <div>
                                            <span
                                              v-for="(itemInst,
                                              indexInst) in classDetail.arrInstructor"
                                              :key="indexInst"
                                            >
                                              {{ itemInst }}
                                              <br />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col no-padding-bottom">
                                      <div class="information-detail">
                                        <div
                                          class="col no-margin-padding"
                                          style="flex: 0 0 10em;"
                                        >
                                          <div>
                                            {{
                                              $t("messages.general.reserveFor")
                                            }}
                                          </div>
                                        </div>
                                        <div class="col no-margin-padding">
                                          <v-btn
                                            text
                                            icon
                                            @click="openDetail()"
                                          >
                                            <v-icon>search</v-icon>
                                          </v-btn>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col no-padding-bottom">
                                      <div class="information-detail">
                                        <div
                                          class="col no-margin-padding"
                                          style="flex: 0 0 10em;"
                                        >
                                          <div>
                                            {{
                                              $t(
                                                "messages.general.examMidTermDate"
                                              )
                                            }}
                                          </div>
                                        </div>
                                        <div class="col no-margin-padding">
                                          <div>
                                            {{ classDetail.EXAM_MIDTERM_DATE }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col no-padding-bottom">
                                      <div class="information-detail">
                                        <div
                                          class="col no-margin-padding"
                                          style="flex: 0 0 10em;"
                                        >
                                          <div>
                                            {{
                                              $t(
                                                "messages.general.examFinalTermDate"
                                              )
                                            }}
                                          </div>
                                        </div>
                                        <div class="col no-margin-padding">
                                          <div>
                                            {{ classDetail.EXAM_FINAL_DATE }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col no-padding-bottom">
                                      <div class="information-detail">
                                        <div
                                          class="col no-margin-padding"
                                          style="flex: 0 0 10em;"
                                        >
                                          <div
                                            style="text-decoration: underline; color: blue"
                                          >
                                            {{ $t("messages.general.remark") }}
                                          </div>
                                        </div>
                                        <div class="col no-margin-padding">
                                          {{
                                            classDetail.CLASSNOTE
                                              ? classDetail.CLASSNOTE
                                              : ""
                                          }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogDetail"
            hide-overlay
            scrollable
            max-width="1024px"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>description</v-icon>
                <v-toolbar-title>{{
                  $t("messages.chkOpenClass.reserveClassDetail")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogDetail = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <div class="information-block">
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.academicYear") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classDetail.ACADYEAR }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.semester") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classDetail.SEMESTER }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.classId") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classDetail.COURSECODE }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.className") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classDetail.COURSENAME }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.section") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <div>{{ classDetail.SECTION2 }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <v-tabs>
                  <v-tab>{{ $t("messages.general.student") }}</v-tab>
                  <v-tab>{{ $t("messages.general.studyPlan") }}</v-tab>
                  <v-tab>{{ $t("messages.general.faculty") }}</v-tab>
                  <v-tab-item>
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th class="text-center">
                              {{ $t("messages.general.seqOrder") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.identity") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.fullname") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in revStudent" :key="index">
                            <td class="text-center">
                              {{ index + 1 }}
                            </td>
                            <td class="text-center">
                              {{ item.STUDENTCODE2 }}
                            </td>
                            <td class="text-center">
                              {{ item.STUNAME }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </v-tab-item>
                  <v-tab-item>
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th class="text-center">
                              {{ $t("messages.general.seqOrder") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.studyPlan") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.studentCodeRange") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.reservedAmount") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in revPlan" :key="index">
                            <td class="text-center">
                              {{ index + 1 }}
                            </td>
                            <td style="white-space: nowrap">
                              {{ item.DESCRIPTION }}
                            </td>
                            <td class="text-center">
                              {{ item.STUDENTCODEFROM }} -
                              {{ item.STUDENTCODETO }}
                            </td>
                            <td class="text-center">{{ item.RESERVESEAT }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </v-tab-item>
                  <v-tab-item>
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th class="text-center">
                              {{ $t("messages.general.seqOrder") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.faculty") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.studentCodeRange") }}
                            </th>
                            <th class="text-center">
                              {{ $t("messages.general.reservedAmount") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in revFaculty" :key="index">
                            <td class="text-center">
                              {{ index + 1 }}
                            </td>
                            <td class="text-center" style="white-space: nowrap">
                              {{ item.FACNAME }}
                            </td>
                            <td class="text-center">
                              {{ item.STUDENTCODEFROM }} -
                              {{ item.STUDENTCODETO }}
                            </td>
                            <td class="text-center">{{ item.RESERVESEAT }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </v-tab-item>
                </v-tabs>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ClassProvider from "@/services/class_provider";

import AcademicYear from "../components/Dropdown/AcademicYear";
import Semester from "../components/Dropdown/Semester";
import Level from "@/components/Dropdown/Level.vue";
import Faculty from "@/components/Dropdown/Faculty.vue";
import Department from "@/components/Dropdown/Department.vue";
import ClassType from "@/components/Dropdown/ClassType.vue";

const classProvider = new ClassProvider();

export default {
  name: "chkOpenClass",
  components: {
    AcademicYear,
    Semester,
    Level,
    Faculty,
    Department,
    ClassType
  },
  data() {
    return {
      dialog: false,
      dialogDetail: false,
      selected: 0,
      selYear: 0,
      selSemester: 0,
      selLvl: 0,
      selFaculty: 0,
      selDepartment: 0,
      selClassType: "",
      txtCourseCode: "",
      txtCourseName: "",
      bTable: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "action",
            label: "",
            thClass: "align-middle"
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "50px",
            sortable: true
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStyle: "100px",
            sortable: true
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp col-250",
            sortable: true
          },
          {
            key: "SECTION_TEXT",
            label: this.$t("messages.general.section"),
            thClass: "align-middle",
            thStyle: "100px",
            sortable: true
          },
          {
            key: "COURSEUNIT",
            label: this.$t("messages.general.credit"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp col-100",
            thStyle: "100px",
            sortable: true
          },
          {
            key: "GRADEMODE",
            label: this.$t("messages.general.grade"),
            thClass: "align-middle text-warp",
            tdClass: "text-center text-nowarp col-100",
            thStyle: "100px",
            sortable: true
          },
          {
            key: "CLASSTIME",
            label: this.$t("messages.general.classTime"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp col-150",
            thStyle: "150px",
            sortable: true
          },
          {
            key: "RESERVEONLY",
            label: this.$t("messages.general.onlyReserved"),
            thClass: "align-middle",
            sortable: true
          },
          {
            key: "CLASSREGIS",
            label: this.$t("messages.general.classStatus"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true
          }
        ]
      },
      perPageOptions: [
        { value: 10, text: 10 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
        { value: 500, text: 500 },
        { value: 1000, text: 1000 },
        { value: 2000, text: 2000 },
        { value: 3000, text: 3000 }
      ],
      perPage: 100,
      currentPage: 1,
      classDetail: {},
      revStudent: [],
      revPlan: [],
      revFaculty: []
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    }
  },
  mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selLvl = 3;
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    async openDialog(data, index) {
      this.togglePreLoader(true);
      this.dialog = true;
      this.selected = index;
      const res = await classProvider.getClassDetail({
        token: this.token,
        request: {
          classid: data.CLASSID,
          lang: this.currentLang
        }
      });
      this.togglePreLoader(false);
      if (res.length > 0) {
        this.classDetail = this.initialSelectedData(res);
      } else {
        this.classDetail = [];
      }
    },
    async openDetail() {
      this.togglePreLoader(true);
      this.dialogDetail = true;
      const param = {
        token: this.token,
        request: {
          classid: this.classDetail.CLASSID,
          lang: this.currentLang
        }
      };
      this.revStudent = await classProvider.getClassReserveByStudent(param);
      this.revPlan = await classProvider.getClassReserveByStudyplan(param);
      this.revFaculty = await classProvider.getClassReserveByFaculty(param);
      this.togglePreLoader(false);
    },
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
    },
    onSelLvlChanged(event) {
      this.selLvl = parseInt(event.target.value);
    },
    onSelFacultyChanged(event) {
      this.selFaculty = parseInt(event.target.value);
    },
    onSelDepartmentChanged(event) {
      this.selDepartment = parseInt(event.target.value);
    },
    onSelClassTypeChanged(event) {
      this.selClassType = event.target.value;
    },
    async handleSearchCls() {
      this.togglePreLoader(true);
      const tempRequest = {
        studentid: 0,
        acadyear: this.selYear,
        semester: this.selSemester,
        levelid: this.selLvl,
        facultyid: this.selFaculty,
        departmentid: this.selDepartment,
        coursegroup: this.selClassType == "NONE" ? "" : this.selClassType,
        structure: this.structure ? "Y" : "N",
        lang: this.currentLang
      };
      if (this.txtCourseCode != "") {
        tempRequest["coursecode"] = this.txtCourseCode;
      }
      if (this.txtCourseName != "") {
        tempRequest["coursename"] = this.txtCourseName;
      }
      var classTimeReq = {
        token: this.token,
        request: tempRequest
      };
      const data = await classProvider.searchOpenCourse(classTimeReq);
      this.bTable.items = [];
      if (data.length > 0) {
        let idx = 0;
        data.map(d => {
          if (d.CLASSTIME != undefined) {
            d.CLASSTIME = this.replaceNewLine(d.CLASSTIME);
          }
          d.rowNumber = idx + 1;
          this.bTable.items.push(d);
          idx++;
        });
      }
      this.togglePreLoader(false);
    },
    replaceNewLine(data) {
      console.log("replaceNewLine", data);
      return data.toString().replace(/\|/g, "<br />");
    },
    handleClearSearchCls() {
      this.txtCourseCode = "";
      this.txtCourseName = "";
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
      this.selLvl = 3;
      this.selFaculty = 0;
      this.selDepartment = 0;
      this.selClassType = "";
    },
    initialSelectedData(data) {
      let result = data[0];
      result.arrInstructor = [];
      if (result.INSTRUCTOR != null) {
        result.arrInstructor = result.INSTRUCTOR.split("|");
      }
      if (result.CLASSTYPE != null) {
        result.CLASSTYPE = this.replaceNewLine(result.CLASSTYPE);
      }
      if (result.CLASSTIME != null) {
        result.CLASSTIME = this.replaceNewLine(result.CLASSTIME);
      }
      if (result.CLASSROOM != null) {
        result.CLASSROOM = this.replaceNewLine(result.CLASSROOM);
      }
      return result;
    }
  },
  watch: {
    currentLang() {
      this.handleSearchCls();
      this.bTable.fields = [
        {
          key: "action",
          label: "",
          thClass: "align-middle"
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "50px",
          sortable: true
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStyle: "100px",
          sortable: true
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp col-250",
          sortable: true
        },
        {
          key: "SECTION_TEXT",
          label: this.$t("messages.general.section"),
          thClass: "align-middle",
          thStyle: "100px",
          sortable: true
        },
        {
          key: "COURSEUNIT",
          label: this.$t("messages.general.credit"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp col-100",
          thStyle: "100px",
          sortable: true
        },
        {
          key: "GRADEMODE",
          label: this.$t("messages.general.grade"),
          thClass: "align-middle text-warp",
          tdClass: "text-center text-nowarp col-100",
          thStyle: "100px",
          sortable: true
        },
        {
          key: "CLASSTIME",
          label: this.$t("messages.general.classTime"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp col-150",
          thStyle: "150px",
          sortable: true
        },
        {
          key: "RESERVEONLY",
          label: this.$t("messages.general.onlyReserved"),
          thClass: "align-middle",
          sortable: true
        },
        {
          key: "CLASSREGIS",
          label: this.$t("messages.general.classStatus"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true
        }
      ];
    }
  }
};
</script>

<style>
.text-nowarp {
  white-space: nowrap;
}
.text-warp {
  white-space: normal;
}
</style>
